<template>
  <div class="card-deck">
    <div v-for="sponsor in sponsors" :key="sponsor.slug" class="card">
      <div class="card-image">
        <contentful-image :image="sponsor.logo" imageClass="card-img-top"/>
      </div>
      <div class="card-body">
        <h5 class="card-title">{{ sponsor.name }}</h5>
        <p class="card-text">{{ sponsor.description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import {createContentfulClient} from "@/api/ContentfulClient";
import {ContentfulImage} from "@/components";

const client = createContentfulClient();

export default {
  name: "SponsorsSection",
  components: {ContentfulImage},
  data() {
    return {
      sponsors: undefined
    }

  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  methods: {
    async fetchData() {
      this.error = this.post = null;
      this.loading = true;
      const entries = await client.getEntries({
        'content_type': 'sponsors',
        'include': 3
      });

      if (entries.total >= 1) {

        this.sponsors = entries.items[0].fields.sponsors.map(sponsor => {
          return {
            slug: sponsor.fields.slug,
            description: sponsor.fields.description,
            name: sponsor.fields.name,
            logo: sponsor.fields.logo
          }
        });
      } else if (entries.errors) {
        await this.$router.push('/')
      }
    }
  }

}
</script>

<style scoped>
@media (min-width: 576px) {
  .card-deck .card {
    min-width: 195px;
    width: 200px;
    max-width: 200px;
    margin-bottom: 20px;
  }
}

.card-image {
  display: flex;
  padding: 10px;
  place-content: center;
  height: 150px;
  horiz-align: center;
}

.card-title, .card-text {
  color: #0e2e5e;
}

</style>
